/*
 * WELLF: welcome-credit modal (£5 for new customers).
 * ---------------------------------------------------------------------------
 * Two states inside one dialog. A: capture the email and "claim". B: pick a plan
 * and go to the cart with the credit applied.
 *
 * THE CODE IS NEVER SHOWN. It rides on a data attribute and is appended to the
 * discount URL. Shopify surfaces it in the cart summary once applied; nothing here
 * invites anyone to copy it.
 *
 * KLAVIYO NEVER BLOCKS. The subscribe call is fired and forgotten. The on-screen
 * flip is what the visitor came for, and a slow or failed list write must not stand
 * between them and the credit. The email is the backup delivery path, not the primary.
 *
 * CART: we never add a second tub. There is one product and one flavour, so anyone
 * arriving here with something in the basket already has the thing they want. On open
 * we read the cart and preselect the plan they are already on; on "use" we only switch
 * the selling plan if they picked a different one, then apply the code through
 * /discount/CODE?redirect=/cart. That route applies the discount and KEEPS the cart.
 * The /cart/{id}:{qty} permalink would have replaced it, silently dropping quantity.
 *
 * Measurement is not done here. This module dispatches wellf:welcome CustomEvents on
 * document and assets/wellf-events.js decides what to send, so consent gating and the
 * GA4/Meta plumbing stay in one file.
 */
(function () {
  'use strict';

  var root = document.getElementById('wellf-modal-welcome');
  if (!root) return;

  var VARIANT = parseInt(root.getAttribute('data-wc-variant'), 10);
  var PLAN_ID = root.getAttribute('data-wc-plan') || '';
  var CODE = root.getAttribute('data-wc-code') || '';
  var LIST = root.getAttribute('data-wc-list') || '';
  var DAYS = parseInt(root.getAttribute('data-wc-days'), 10) || 3;
  var CONTEXT = root.getAttribute('data-wc-context') || 'pdp';   // pdp | cart

  var form = root.querySelector('[data-wc-form]');
  var emailEl = root.querySelector('#wc-email');
  var errEl = root.querySelector('[data-wc-err]');
  var useErrEl = root.querySelector('[data-wc-userr]');
  var claimBtn = root.querySelector('[data-wc-claim]');
  var useBtn = root.querySelector('[data-wc-use]');
  var stamp = root.querySelector('[data-wc-stamp]');
  var sheen = root.querySelector('[data-wc-sheen]');
  var byEl = root.querySelector('[data-wc-by]');
  var planBtns = Array.prototype.slice.call(root.querySelectorAll('[data-wc-planopt]'));

  var claimed = false;
  var used = false;
  var planTouched = false;
  var plan = PLAN_ID ? 'subscribe' : 'one_time';

  function root_() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  var openedVia = 'manual';   // set to 'auto' by the trigger below before it opens

  function emit(type, extra) {
    var detail = { type: type, via: openedVia };
    if (extra) { for (var k in extra) { if (extra.hasOwnProperty.call(extra, k)) detail[k] = extra[k]; } }
    try { document.dispatchEvent(new CustomEvent('wellf:welcome', { detail: detail })); } catch (e) {}
  }
  function show(sel, on) {
    Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) { el.hidden = !on; });
  }
  function reduced() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }

  // ── plan selection ──
  function setPlan(next, touched) {
    if (next === plan) return;
    plan = next;
    if (touched) planTouched = true;
    planBtns.forEach(function (b) {
      var on = b.getAttribute('data-wc-planopt') === plan;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (touched) emit('plan_toggle', { plan: plan });
  }
  planBtns.forEach(function (b) {
    b.addEventListener('click', function () { setPlan(b.getAttribute('data-wc-planopt'), true); }, { passive: true });
  });

  // ── read the cart so we can preselect the plan they are already on ──
  var cartLine = null;   // { key, quantity, hasPlan } for our variant, or null
  function readCart() {
    return fetch(root_() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        cartLine = null;
        if (!c || !c.items) return;
        for (var i = 0; i < c.items.length; i++) {
          if (c.items[i].id === VARIANT) {
            cartLine = {
              key: c.items[i].key,
              quantity: c.items[i].quantity,
              hasPlan: !!c.items[i].selling_plan_allocation
            };
            break;
          }
        }
        if (cartLine && !claimed) setPlan(cartLine.hasPlan ? 'subscribe' : 'one_time', false);
      })
      .catch(function () {});
  }

  // ── claim ──
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  function claim() {
    var email = (emailEl && emailEl.value || '').trim();
    if (!validEmail(email)) {
      if (emailEl) emailEl.classList.add('err');
      if (errEl) errEl.hidden = false;
      emit('invalid_email');
      if (emailEl) emailEl.focus();
      return;
    }
    if (emailEl) emailEl.classList.remove('err');
    if (errEl) errEl.hidden = true;

    // Fire and forget. Never await this before flipping the card.
    try {
      if (window.WellfKlaviyo && LIST) {
        window.WellfKlaviyo.subscribe(LIST, email, { source: 'PDP welcome credit' }).catch(function () {});
      }
    } catch (e) {}

    claimed = true;
    root.classList.add('is-claimed');

    var by = new Date();
    by.setDate(by.getDate() + DAYS);
    if (byEl) {
      try {
        byEl.textContent = by.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
      } catch (e) { byEl.textContent = ''; }
    }

    show('[data-wc-a]', false);
    show('[data-wc-b]', true);

    if (!reduced()) {
      if (sheen) { sheen.classList.remove('run'); void sheen.offsetWidth; sheen.classList.add('run'); }
      if (stamp) { stamp.classList.remove('thump'); void stamp.offsetWidth; stamp.classList.add('thump'); }
    }

    emit('claim');

    // On the cart there is no decision left to make: the product is already in the bag, so
    // the claim IS the use. Let the stamp thump land, then apply the code. The redirect
    // route keeps the cart and comes straight back here with the discount on.
    if (CONTEXT === 'cart') {
      used = true;
      if (useBtn) useBtn.disabled = true;
      emit('use', { plan: plan, plan_changed: false, auto_applied: 1 });
      setTimeout(go, reduced() ? 150 : 700);
      return;
    }
    if (useBtn) setTimeout(function () { try { useBtn.focus(); } catch (e) {} }, 120);
  }

  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); claim(); });
  }
  if (emailEl) {
    emailEl.addEventListener('input', function () {
      emailEl.classList.remove('err');
      if (errEl) errEl.hidden = true;
    }, { passive: true });
  }

  // ── use it: get the cart into the right shape, then apply the code ──
  function go() {
    var url = root_() + 'discount/' + encodeURIComponent(CODE) +
              '?redirect=' + encodeURIComponent(root_() + 'cart');
    window.location.href = url;
  }

  // A failed add used to redirect anyway, landing the visitor on /cart holding a discount
  // with an empty bag, which is the worst possible moment to fail. Recover the button so
  // they can try again, and say so. `used` is released because nothing was used.
  function failUse() {
    used = false;
    if (useBtn) useBtn.disabled = false;
    if (useErrEl) useErrEl.hidden = false;
    emit('use_failed', { plan: plan });
  }

  function use() {
    if (used) return;
    used = true;
    emit('use', { plan: plan, plan_changed: planTouched });
    if (useBtn) { useBtn.disabled = true; }
    if (useErrEl) useErrEl.hidden = true;

    var wantPlan = (plan === 'subscribe' && PLAN_ID) ? PLAN_ID : '';

    // Already in the cart: change the plan if needed, never change the quantity.
    if (cartLine) {
      var isSub = cartLine.hasPlan;
      var wantSub = !!wantPlan;
      if (isSub === wantSub) { go(); return; }
      var body = { id: cartLine.key, quantity: cartLine.quantity };
      body.selling_plan = wantSub ? wantPlan : null;
      // The item is already in the bag here, so a failed plan switch still leaves them a
      // correct cart with the discount on it. Going on is right; only the plan is stale.
      fetch(root_() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(go).catch(go);
      return;
    }

    // Empty cart: add exactly one. fetch only rejects on a network error, so a 422 (sold
    // out, stale selling plan) arrives as a resolved response and has to be read.
    var add = { id: VARIANT, quantity: 1 };
    if (wantPlan) add.selling_plan = wantPlan;
    fetch(root_() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(add)
    }).then(function (r) {
      if (r && r.ok) { go(); return; }
      // Non-OK. The add may still have landed, so ask the cart rather than guessing: a
      // blind retry would risk two of them in the bag.
      readCart().then(function () { if (cartLine) go(); else failUse(); });
    }).catch(function () {
      readCart().then(function () { if (cartLine) go(); else failUse(); });
    });
  }

  if (useBtn) useBtn.addEventListener('click', use, { passive: true });

  // ── open / close ──
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-wellf-modal-open="welcome"]');
    if (opener) {
      // The cart strip is a third way in, distinct from the PDP line and the auto-open.
      openedVia = opener.getAttribute('data-wc-source') === 'cart-strip' ? 'cart' : 'manual';
      readCart();
    }
  }, { passive: true });

  // The shared controller in klaviyo-forms.js closes by setting [hidden], and it can be
  // closed by the backdrop, the X or Escape. Watching the attribute catches all three
  // without reaching into that module.

  // ═════════════════════════════════════════════════════════════════════════
  // AUTO-OPEN TRIGGER
  // The line is tapped by ~1.6% of the people who dwell on the plan cards, so the offer
  // effectively does not exist for the other 98%. This opens the SAME modal on its own,
  // for a narrow slice, at a moment that is theirs rather than ours.
  //
  // THE ONE RULE THAT SHAPES EVERYTHING: qualify and fire run on DIFFERENT evidence.
  // Qualify is appreciation, engaged time and depth and dwell in the content zones BELOW
  // the buy card. Fire is hesitation, dwell and re-entry on the price. If both layers read
  // the price the gate is decorative, and the profile it catches is "landed, saw the price,
  // left", which is the bargain hunter we are deliberately NOT chasing. The offer is a
  // reward for interest, not a rescue for a bounce.
  //
  // Zone counters come from wellf-vitals.js rather than being recomputed, so the thing that
  // fires the modal and the thing we measure afterwards cannot drift. Consent does not gate
  // any of this: it gates the SEND inside vitals, not the ticker, so this runs for 100% of
  // sessions.
  // ═════════════════════════════════════════════════════════════════════════
  (function autoOpen() {
    var CFG = {
      ARRIVAL_GRACE_MS:    20000,  // never on arrival, however qualified they look
      QUALIFY_ENGAGED_MS:  30000,  // visible time, not wall clock. 24% of sessions reach it
      QUALIFY_SCROLL_PCT:  50,     // 19% of sessions
      QUALIFY_CONTENT_MS:  5000,   // cumulative below the buy card. Median session: 0ms
      FIRE_PRICE_DWELL_MS: 8000,   // p90 of plancards dwell is 10.3s, so this is top-decile
      FIRE_REENTRY_MIN_MS: 3000,   // re-entry alone catches skimmers: 24 of 76 had <3s
      FIRE_IDLE_MS:        20000,
      OVERLAY_SETTLE_MS:   4000,   // after any overlay closes
      PROOF_READ_MS:       6000,   // after opening a proof or FAQ block
      TICK_MS:             500
    };
    var CONTENT_ZONES = ['formula', 'faq', 'reviews', 'socialproof'];
    var SEEN_KEY = 'wellf_welcome_auto_v1';

    if (root.getAttribute('data-wc-auto') !== 'true') return;   // kill switch + eligibility, decided in Liquid
    var DEBUG = root.getAttribute('data-wc-debug') === 'true';
    function log() { if (DEBUG) { try { console.log.apply(console, ['[wellf-welcome]'].concat([].slice.call(arguments))); } catch (e) {} } }

    try { if (localStorage.getItem('wellf_track') === 'off') { log('suppressed: internal traffic'); return; } } catch (e) {}
    try { if (localStorage.getItem(SEEN_KEY)) { log('suppressed: already seen'); return; } } catch (e) {}
    function markSeen() { try { localStorage.setItem(SEEN_KEY, String(Date.now())); } catch (e) {} }

    var started      = Date.now();
    var engagedMs    = 0;
    var lastTick     = Date.now();
    var maxScrollPct = 0;
    var lastActivity = Date.now();
    var overlayLeftAt = -1;
    var proofOpenedAt = -1;
    var addedToBag   = false;
    var fired        = false;
    var openFails    = 0;
    var OPEN_MAX_TRIES = 3;
    var qualifiedBy  = null;

    // once claimed or dismissed, never again on any visit
    document.addEventListener('wellf:welcome', function (e) {
      var t = e && e.detail && e.detail.type;
      if (t === 'claim' || t === 'dismiss' || t === 'use') markSeen();
    });

    function bump() { lastActivity = Date.now(); }
    ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (t) {
      document.addEventListener(t, bump, { passive: true, capture: true });
    });

    var lastY = window.scrollY || 0, lastYAt = Date.now(), exitIntent = false;
    window.addEventListener('scroll', function () {
      bump();
      var y = window.scrollY || 0, now = Date.now(), dt = now - lastYAt;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0) maxScrollPct = Math.max(maxScrollPct, Math.round((y / h) * 100));
      // mobile has no mouseleave. A hard flick upward is the closest honest proxy for
      // "I am leaving", and requiring real velocity keeps ordinary re-reading out of it.
      if (dt > 0 && dt < 400 && (lastY - y) / dt > 1.8 && y < lastY - 250) exitIntent = true;
      lastY = y; lastYAt = now;
    }, { passive: true });

    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) exitIntent = true;
    }, { passive: true });

    var awayReturn = false;
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') { awayReturn = true; bump(); }
    });

    // they are buying: stand down for good
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-buy-add]')) addedToBag = true;
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-buy-add]')) addedToBag = true;
      // any proof or FAQ opening starts a reading window we must not interrupt
      if (e.target.closest && (e.target.closest('[data-wellf-modal-open]') ||
          e.target.closest('summary') || e.target.closest('[data-wellf-acc]'))) proofOpenedAt = Date.now();
    }, true);

    function cartNotEmpty() {
      try { return !!document.querySelector('.cart-bubble:not(.visually-hidden)'); } catch (e) { return false; }
    }
    // The taste reel is the one thing on this page that demands attention without being a
    // modal. It is not [data-wellf-modal], it does not lock body scroll, so anyOverlayOpen()
    // cannot see it, and watching a video involves no pointer or scroll activity, so the
    // 20s idle branch would otherwise fire straight over someone watching it WITH SOUND.
    //
    // Checked by the reel's own is-playing class rather than "any video playing", because
    // the formula-section gummy loop autoplays from an IntersectionObserver: a blanket video
    // check would suppress the trigger for good every time that scrolled into view.
    function reelPlaying() {
      try { return !!document.querySelector('[data-wellf-reel].is-playing'); } catch (e) { return false; }
    }
    function overlayOpen() {
      try {
        return !!(window.WellfKlaviyo && window.WellfKlaviyo.anyOverlayOpen && window.WellfKlaviyo.anyOverlayOpen());
      } catch (e) { return true; }
    }
    function zones() {
      try { return (window.WellfZones && window.WellfZones.read()) || {}; } catch (e) { return {}; }
    }

    function qualify(z) {
      if (qualifiedBy) return qualifiedBy;
      if (engagedMs >= CFG.QUALIFY_ENGAGED_MS) return (qualifiedBy = 'engaged_time');
      if (maxScrollPct >= CFG.QUALIFY_SCROLL_PCT) return (qualifiedBy = 'scroll_depth');
      var content = 0;
      for (var i = 0; i < CONTENT_ZONES.length; i++) {
        var zz = z[CONTENT_ZONES[i]];
        if (zz) content += zz.ms;
      }
      if (content >= CFG.QUALIFY_CONTENT_MS) return (qualifiedBy = 'content_zones');
      return null;
    }

    function fireReason(z) {
      var pc = z.plancards || { ms: 0, re: 0 };
      if (pc.ms >= CFG.FIRE_PRICE_DWELL_MS) return 'price_dwell';
      if (pc.re >= 1 && pc.ms >= CFG.FIRE_REENTRY_MIN_MS) return 'price_reentry';
      if (exitIntent) return 'exit_intent';
      if (awayReturn) return 'away_return';
      if (Date.now() - lastActivity >= CFG.FIRE_IDLE_MS) return 'idle';
      return null;
    }

    function tick() {
      if (fired) return;
      var now = Date.now();
      if (document.visibilityState === 'visible') engagedMs += Math.min(now - lastTick, CFG.TICK_MS * 4);
      lastTick = now;

      if (now - started < CFG.ARRIVAL_GRACE_MS) return;
      if (addedToBag || cartNotEmpty()) return;
      if (!root.hidden) return;                       // already open, by any route
      if (overlayOpen()) { overlayLeftAt = now; return; }
      // treated as a reading window, so it also gets the settle once playback stops
      if (reelPlaying()) { proofOpenedAt = now; return; }
      if (overlayLeftAt > 0 && now - overlayLeftAt < CFG.OVERLAY_SETTLE_MS) return;
      if (proofOpenedAt > 0 && now - proofOpenedAt < CFG.PROOF_READ_MS) return;

      var z = zones();
      var q = qualify(z);
      if (!q) return;
      var r = fireReason(z);
      if (!r) return;

      fired = true;
      openedVia = 'auto';
      log('opening. qualified by', q, 'fired by', r, { engagedMs: engagedMs, scroll: maxScrollPct, plancards: z.plancards });
      try {
        // markSeen() used to run before this call. If openModal threw (WellfKlaviyo absent
        // because klaviyo-forms.js did not load) the visitor was recorded as having seen a
        // £5 offer they never saw, permanently and with no event to show it. Mark only once
        // the modal is actually open, and report the failure so it stops being invisible.
        window.WellfKlaviyo.openModal('welcome');
        markSeen();
        readCart();
        // The open itself has to be an event, or the funnel has a numerator with no
        // denominator: claims would arrive tagged via=auto with nothing to divide by. This
        // also carries WHICH signal qualified and which fired, which is the only way to tune
        // the thresholds later without guessing.
        emit('auto_shown', { qualified_by: q, fired_by: r });
      } catch (e) {
        log('open failed', e);
        openFails++;
        openedVia = 'manual';
        // Report once, on the first failure only: the tick runs twice a second and this
        // must not become a loop that spams the beacon.
        if (openFails === 1) emit('auto_open_failed', { qualified_by: q, fired_by: r });
        // Let a later tick try again rather than burning the offer on one bad attempt,
        // but give up after a few: if WellfKlaviyo is absent it is absent for good.
        if (openFails < OPEN_MAX_TRIES) fired = false;
      }
    }

    setInterval(tick, CFG.TICK_MS);
    log('armed');
  })();

  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (root.hidden && !used) {
        emit('dismiss', { stage: claimed ? 'post_claim_pre_use' : 'pre_claim' });
      }
    }).observe(root, { attributes: true, attributeFilter: ['hidden'] });
  }
})();
